import React, { Component } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import { DropTarget, DragDropContext } from 'react-dnd';
import DraggableBox from './DraggableBox';

const boxTarget = {
  drop(props, monitor, component) {
    const item = monitor.getItem();
    const delta = monitor.getDifferenceFromInitialOffset();
    const left = Math.round(item.left + delta.x);
    const top = Math.round(item.top + delta.y);
    component.moveBox(item.id, left > 0 ? left : 0, top > 0 ? top : 0);
  },
};

class InfographicView extends Component {
  moveBox(id, left, top) {
    this.props.moveBox(id, left, top);
  }

  render() {
    const { connectDropTarget, image, imageAlt, boxes } = this.props;
    return connectDropTarget(
      <div style={{ position: 'relative' }}>
        <img
          src={image}
          alt={imageAlt}
          style={{
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        {boxes.map(b => (
          <DraggableBox
            key={b.id}
            id={b.id}
            description={b.description}
            value={b.value}
            unit={b.unit}
            color={b.color}
            valueInRange={b.value >= b.zero && b.value <= b.zero + b.span}
            left={b.left}
            top={b.top}
          />
        ))}
      </div>
    );
  }
}

const WrappedInfographicView = DropTarget(
  'infographic-box',
  boxTarget,
  connect => {
    return {
      connectDropTarget: connect.dropTarget(),
    };
  }
)(InfographicView);
export default DragDropContext(HTML5Backend)(WrappedInfographicView);



// WEBPACK FOOTER //
// ./src/components/Infographic/InfographicView.js